import styled from 'styled-components';

export const Badge = styled.span`
	display: inline-block;
	padding: 2px 12px;
	color: white;
	background-color: green;
	border-radius: 4px;
	font-size: 11px;
`;